import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchJobGrade = createAsyncThunk(
  'jobGrade/fetchJobGrade',
  async (params) => {
    const response = await Lookup.GetJobGrade();
    const mappedData =
      response?.data?.data?.map((item) => ({
        id: item.id,
        nameEn: item.nameEn,
        nameAr: item.nameAr,
        code: item.code,
        label: item.name,
        value: item.id,
      })) ?? [];
    return [firstListItem, ...mappedData];
  }
);

const initialState = {
  jobGradeList: [],
  loading: false,
  error: '',
};

const jobGradeSlice = createSlice({
  name: 'jobGrade',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchJobGrade.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchJobGrade.fulfilled, (state, action) => {
      state.loading = false;
      state.jobGradeList = action.payload;
      state.error = '';
    });
    builder.addCase(fetchJobGrade.rejected, (state, action) => {
      state.loading = false;
      state.jobGradeList = [];
      state.error = action.error?.message ?? '';
    });
  },
});

export default jobGradeSlice.reducer;
